import { limiteTamanhoArquivo } from './constants';

 const isCPF = (number) => {
  let sum;
  let rest;
  sum = 0;
  let message = {message: "CPF inválido."};

  // eslint-disable-next-line no-useless-escape
  number = number.replace(/\-|\./g, '');
  if (number === "00000000000") return message;
  if (number === "99999999999") return message;

  for (let i=1; i<=9; i++) sum = sum + parseInt(number.substring(i-1, i)) * (11 - i);
  rest = (sum * 10) % 11;

  if ((rest === 10) || (rest === 11))  rest = 0;
  if (rest !== parseInt(number.substring(9, 10)) ) return message;

  sum = 0;
  for (let i = 1; i <= 10; i++) sum = sum + parseInt(number.substring(i-1, i)) * (12 - i);
  rest = (sum * 10) % 11;

  if ((rest === 10) || (rest === 11))  rest = 0;
  if (rest !== parseInt(number.substring(10, 11) ) ) return message;
  return true;
}

const isDate = (condition, value1, value2, message) => {

let v1 = value1.split("/");
value1 = new Date(v1[2] + "-" + v1[1] + "-" + v1[0]);

if (value1 instanceof Date)
  switch (condition) {
    case ">":  return value1 <= value2 ? {message: message} : true;
    case ">=":  return value1 < value2 ? {message: message} : true;
    case "<":  return value1 >= value2 ? {message: message} : true;
    case "<=":  return value1 > value2 ? {message: message} : true;
    case "===":  return value1 !== value2 ? {message: message} : true;
    case "<>":  return value1 === value2 ? {message: message} : true;
    default: return true;
  }
else
  return {message: "Data inválida."}
}

const validatePaisporDocumento = (pais, tipoDocumento, tipoPessoa, value, message, message2) => {

  let tipoPessoaId = 0;

  switch (tipoPessoa) {
    case "PessoaFisica": tipoPessoaId = 1; break;
    case "PessoaJuridica": tipoPessoaId = 2; break;
    case "PessoaEstrangeira": tipoPessoaId = 3; break;
    default:
  }

  if(tipoDocumento !== value && tipoPessoaId === 3 && pais === 'BRASIL'){
    return {message: message}
  }

  if(tipoDocumento === value && tipoPessoaId === 3 && pais !== 'BRASIL'){
    return {message: message2}
  }

  return true
}


const isCNPJ = (cnpj) => {
  let tamanho, numeros, digitos, soma, pos, resultado = null;
  cnpj = cnpj.replace(/[^\d]+/g,'');
  if(cnpj === '') return {message: "CNPJ inválido."}; 
  if (cnpj.length !== 14)
  return {message: "CNPJ inválido."}; 
  // Elimina CNPJs invalidos conhecidos
  if (cnpj === "00000000000000" || 
      cnpj === "11111111111111" || 
      cnpj === "22222222222222" || 
      cnpj === "33333333333333" || 
      cnpj === "44444444444444" || 
      cnpj === "55555555555555" || 
      cnpj === "66666666666666" || 
      cnpj === "77777777777777" || 
      cnpj === "88888888888888" || 
      cnpj === "99999999999999")
      return {message: "CNPJ inválido."};   
  // Valida DVs
  tamanho = cnpj.length - 2
  numeros = cnpj.substring(0,tamanho);
  digitos = cnpj.substring(tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado.toString() !== digitos.charAt(0))
      return {message: "CNPJ inválido."};
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0,tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado.toString() !== digitos.charAt(1))
    return {message: "CNPJ inválido."};
         
  return true;
  
}

const validarTamanhoArq = (isIdentity, file) => {
  //1mb = 1048576
  const Limite = isIdentity ? limiteTamanhoArquivo.Identificacao * 1048576 : limiteTamanhoArquivo.Outros * 1048576;
  return file.size > Limite;
}

export default {
  isCPF: isCPF,
  isDate: isDate,
  isCNPJ: isCNPJ,
  validatePaisporDocumento: validatePaisporDocumento,
  validarTamanhoArq: validarTamanhoArq
}

